import React from "react";
import { Tooltip } from "antd";

import { SUPPORTED_LANGUAGES, useTranslation } from "./LanguageProvider";

/**
 * Compact MN / EN toggle.
 *
 * Rendered as a small pill so it can sit inline next to the user's role in the sidebar without
 * competing with the navigation. `tone="dark"` suits the sidebar, `tone="light"` the login card.
 */
const TONES = {
    dark: {
        wrapper: "border-white/10 bg-white/[0.06]",
        active: "bg-white/20 text-white",
        idle: "text-white/45 hover:text-white/80",
    },
    light: {
        wrapper: "border-slate-200 bg-slate-100",
        active: "bg-white text-slate-900 shadow-sm",
        idle: "text-slate-500 hover:text-slate-800",
    },
};

function LanguageSwitcher({ tone = "dark", placement = "top", className = "" }) {
    const { language, setLanguage, t } = useTranslation();
    const styles = TONES[tone] || TONES.dark;

    return (
        <Tooltip title={t("lang.switch")} placement={placement}>
            <div
                role="group"
                aria-label={t("lang.switch")}
                className={`inline-flex shrink-0 items-center gap-[2px] rounded-full border p-[2px] ${styles.wrapper} ${className}`}
            >
                {SUPPORTED_LANGUAGES.map((item) => {
                    const isActive = item.value === language;

                    return (
                        <button
                            key={item.value}
                            type="button"
                            aria-pressed={isActive}
                            title={item.label}
                            onClick={() => setLanguage(item.value)}
                            className={`rounded-full px-[7px] py-[3px] text-[10px] font-semibold leading-none tracking-wider transition-colors duration-150 ${
                                isActive ? styles.active : styles.idle
                            }`}
                        >
                            {item.short}
                        </button>
                    );
                })}
            </div>
        </Tooltip>
    );
}

export default LanguageSwitcher;
